import { GridActionsCellItem } from "@mui/x-data-grid";
import { useEffect, useRef, useState } from "react";
import { AiOutlinePlus } from "react-icons/ai";
import { BiDotsHorizontalRounded } from "react-icons/bi";
import CustomStyledTable from "../../../../../components/table/CustomStyledTable";
import useEditFormStore from "../../../../../state-management/useEditFormStore";
import { Columns } from "./data";
import CompanyIdModalForm from "./company_id_modal";
import { useManageTableWithSearchParams } from "../../../../../helpers/useManageTable";
import useCompanyStore from "../../../../../state-management/useCompanyStore";
import TableFilter from "../../../../../components/table/filter/TableFilter";
import { Popover } from "@mui/material";
import { BsPencil, BsTrash } from "react-icons/bs";
import DeleteModal from "../../../../../components/modals/DeleteModal";
import { IdTypePaginator } from "../../../../../models/identity-document-type.dto";
import {
	useDeleteIdType,
	useGetIdType,
} from "../../../../../services/identity-type-document.service";
import { departmentColumns } from "./tanstack-columns";
import TanStackEmployeeTable from "../../../../../components/table/TanStackEmployeeTable";
import { useTableConfiguration } from "../../../../../helpers/useTableConfiguration";
import { TableId } from "../../../../../models/table-configuration.dto";
import useUserStore from "../../../../../state-management/useUserStore";

const CompanyIds = () => {
	const { currentCompany } = useCompanyStore();
	const { formDataValues, setFormData } = useEditFormStore();
	const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);
	const [openModal, setOpenModal] = useState(false);
	const [openDeleteModal, setOpenDeleteModal] = useState(false);
	const [isEditForm, setIsEditForm] = useState(false);
	const { currentUser, userType } = useUserStore();

	const {
		tableAPIRef,
		fetchedTableData,
		tableData,
		isLoading,
		pageCount,
		setTableData,
	} = useManageTableWithSearchParams<IdTypePaginator>({
		fetchHook: (options) => useGetIdType(options),
	});

	const { mutate: deleteIdType } = useDeleteIdType();

	const handleDeleteMethod = () => {
		deleteIdType(
			{ id: formDataValues?.id },
			{
				onSuccess: () => {
					setOpenDeleteModal(false);
				},
			}
		);
	};

	const additionalColumns = [
		{
			field: "actions",
			type: "actions",
			headerName: "Actions",
			minWidth: 150,
			flex: 1,
			headerClassName: "super-app-theme--header",
			cellClassName: "actions",
			getActions: (params: any) => {
				return [
					<GridActionsCellItem
						icon={<BiDotsHorizontalRounded />}
						label="actions"
						onClick={(e) => {
							setFormData(params.row);
							setAnchorEl(e.currentTarget);
						}}
					/>,
				];
			},
		},
	];

	const columnsWithAdditions = Columns.filter(
		(col) => col.field !== "active"
	).map(
		(col) => additionalColumns.find((add) => add.field === col.field) || col
	);

	return (
		<div>
			<h2 className="text-2sm font-semibold mb-3">Company IDs</h2>
			<hr />
			<div className="flex items-center justify-between mt-7 mb-8">
				<div className="flex items-center gap-3">
					{/*<APISearchInput*/}
					{/*    fallbackData={fetchedTableData}*/}
					{/*    setTableData={setTableData}*/}
					{/*    mutate={useGetIdType} // Use the search hook here if applicable*/}
					{/*/>*/}
					<TableFilter
						fields={[
							{
								title: "Sort by",
								fieldName: "",
								fieldType: "SORT",
								options: [
									{ title: "Name", fieldName: "name" },
									{ title: "Code", fieldName: "code" },
									// Add more filter options as needed
								],
							},
							// {
							//     title: "Active",
							//     fieldType: "YES_NO",
							//     fieldName: "active",
							// }
						]}
					/>
				</div>
				<div
					className="flex items-center text-primary-blue text-sm cursor-pointer w-fit"
					onClick={() => {
						setAnchorEl(null);
						setIsEditForm(false);
						setOpenModal(true);
					}}
				>
					<AiOutlinePlus className="mr-1 text-sm" />
					Add New Company ID
				</div>
			</div>
			<TanStackEmployeeTable
				tableId={TableId.COMPANY_IDS}
				data={tableData}
				columns={departmentColumns}
				loading={isLoading}
				onRowClick={(row, event) => {
					setFormData(row);
					setAnchorEl(event.currentTarget);
				}}
				onActionClick={(row, event) => {
					setFormData(row);
					setAnchorEl(event.currentTarget);
				}}
				initialColumnVisibility={{}}
				pageSize={10}
				pageCount={pageCount}
				apiRef={tableAPIRef}
			/>
			{/* <CustomStyledTable
				rows={tableData}
				columns={columnsWithAdditions}
				apiRef={tableAPIRef}
				loading={isLoading}
				pageCount={pageCount}
				setAnchorEl={setAnchorEl}
			/> */}
			<Popover
				id={anchorEl ? "simple-popover" : undefined}
				open={Boolean(anchorEl)}
				anchorEl={anchorEl}
				onClose={() => setAnchorEl(null)}
				anchorOrigin={{
					vertical: "bottom",
					horizontal: "left",
				}}
				PaperProps={{
					style: {
						width: "auto",
						borderRadius: 8,
						display: "flex",
						justifyContent: "center",
					},
				}}
			>
				<div className="flex flex-col justify-center p-3 text-secondary-darkgray">
					<div
						onClick={() => {
							setIsEditForm(true);
							setOpenModal(true);
							setAnchorEl(null);
						}}
						className="table-action-popover"
					>
						<BsPencil />
						<p className="text-2sm">Edit</p>
					</div>
					<div
						onClick={() => {
							setOpenDeleteModal(true);
							setAnchorEl(null);
						}}
						className="table-action-popover"
					>
						<BsTrash />
						<p className="text-2sm">Delete</p>
					</div>
				</div>
			</Popover>
			<DeleteModal
				openDeleteModal={openDeleteModal}
				spanContent={formDataValues?.name || ""}
				setOpenDeleteModal={setOpenDeleteModal}
				handleDeleteMethod={handleDeleteMethod}
			/>
			{openModal && (
				<CompanyIdModalForm
					open={openModal}
					setOpen={setOpenModal}
					title={isEditForm ? "Update Company ID" : "Add New Company ID"}
					isEditForm={isEditForm}
				/>
			)}
		</div>
	);
};

export default CompanyIds;
